import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export { DEFAULT_BREAKPOINTS } from './constants';
export const adjustBreakpointHeight = (breakpoints, heightDelta)=>breakpoints.map((point)=>{
        var _point_elementHeight;
        return _object_spread_props(_object_spread({}, point), {
            elementHeight: (_point_elementHeight = point.elementHeight) !== null && _point_elementHeight !== void 0 ? _point_elementHeight : 0 + heightDelta
        });
    });
export const createGridBreakpoint = ({ screenWidth: maxWidth, containerWidth, elementSpacing, elementHeight, elementsPerRow })=>({
        maxWidth,
        elementWidth: (containerWidth + elementSpacing) / (elementsPerRow + elementSpacing) - elementSpacing,
        elementHeight
    });
